
// Highlight / Selection types
export const OptimiserEditorSelectionTypes = {
  none: 'none',
  allocation: 'allocation',
  nodeEdge: 'nodeEdge',
  cuttingLine: 'cuttingLine',
  reliefCut: 'reliefCut',
  cutout: 'cutout'
}
